import React from 'react';
import {doLogout} from '../../views/logout';
const common = require('../../common/common');
const env = require("../../../config.js").default;

class E401 extends React.Component {
  componentDidMount(){
    document.title = env.APP_NAME;
  }
  componentWillMount(){
    document.getElementById('body').className='content_page';
  }
  render(props){
    return (
      <div className="tab-content">
				<div className="row" style={{alignItems: "center", height: "calc(100vh - var(--header-height) - var(--footer-height))"}}>
					<div className="col-xl-12 text-center content_error">
						<h1 className="animated fadeInUp delay-03s">
              {common.getTrad("Errore")} <span>401</span>
            </h1>
						<h3 className="animated fadeInUp delay-06s">
              {common.getTrad("Utente non abilitato.")}
            </h3>
						<br/>
					</div>
				</div>
      </div>
    )
  }
}

export default E401;
